import type { ReactElement } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import {
  ChartColumn,
  ChartPie,
  Goals,
  Idea,
  MagicWandFilled,
  Rocket,
} from '@mint-lib/icons';

export type Prompt = {
  question: string;
  icon?: ReactElement;
};

export type PromptCard = {
  prompt: Prompt;
  onStartNewChat: ({ text }: { text: string }) => void;
  isAiProcessing: boolean;
};

export const usePrompts = () => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  const desktopPrompts: Prompt[] = [
    {
      icon: <Rocket className="fill-icon-primary" />,
      question: t('How are my campaigns going?'),
    },
    {
      icon: <ChartColumn className="fill-icon-primary" />,
      question: t('Show top 5 performing platform on clicks.'),
    },
    {
      icon: <ChartPie className="fill-icon-primary" />,
      question: t('Show me the spend split by platform.'),
    },
    {
      icon: <MagicWandFilled className="fill-icon-primary" />,
      question: t('Run a forecast.'),
    },
    {
      icon: <Goals className="fill-icon-primary" />,
      question: t('Create a media plan.'),
    },
    {
      icon: <Idea className="fill-icon-primary" />,
      question: t('Show me spent split by month in this year.'),
    },
  ];

  const mobilePrompts: Prompt[] = [
    {
      question: t('Show me the spend split by platform.'),
    },
    {
      question: t('Show me the status of my campaigns'),
    },
    {
      question: t('Which are the top 5 platforms driving clicks?'),
    },
  ];

  const redmillPrompts: Prompt[] = [
    {
      question: t(
        'What are my total savings across my top 5 spending markets?',
      ),
    },
    {
      question: t(
        'Which channel is driving the most savings across my top 5 spending markets?',
      ),
    },
    {
      question: t(
        'Which media title is driving the most savings across my top 5 spending markets?',
      ),
    },
    {
      question: t('What are my savings this year versus last year?'),
    },
    {
      question: t('What is my current TV PIB?'),
    },
    {
      question: t('Which markets are not meeting their Google guarantees?'),
    },
  ];

  return {
    desktopPrompts,
    mobilePrompts,
    redmillPrompts,
  };
};
